import { SessionComponentCanDeactivate } from './can-deactivate/sessioncomponent-can-deactivate';

export abstract class FormSessionCanDeactivate extends SessionComponentCanDeactivate {
  canDeactivate(): boolean {
    return false
  }
}